import { render, staticRenderFns } from "./DropBox.vue?vue&type=template&id=15e93182&scoped=true&"
import script from "./DropBox.vue?vue&type=script&lang=js&"
export * from "./DropBox.vue?vue&type=script&lang=js&"
import style0 from "./DropBox.vue?vue&type=style&index=0&id=15e93182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e93182",
  null
  
)

export default component.exports